<!--
 * 文件名：LabelPersonTaskSum.vue
 * 描述：数据标注行-人员明细弹框（v26.3.3 N7 行级化，02sheet 拍板交互）。
 *       按标注明细行分页查执行人明细（itemPageList），复选框 + 初审/复审两列行内下拉 +
 *       列头齿轮批量设置（对勾选行统一赋该列人员）；质检锁死只读=任务包发起人（拆分时自动写入）。
 *       前端预演校验与后端一致：质检逐行非空、初审/复审行间联动（全有或全无）、三类人员≠该行标注人（自审禁止）。
 * 契约（2026-09-23 执行方口径·二修订）：
 *   初审/复审下拉候选同池=执行方认证池（personnel /staff-cert/label-assign-candidates 只传租户=该租户
 *     is_cert_audit=Y 全量；执行方=非转派委托方/药企、转派三方，父组件按包算好经 candidateTenantGuid 传入）；
 *   初审默认勾选=循环交叉互审（受理拆分后端默认写库+存量老拆分包打开时前端兜底预填，映射源=执行人全集——
 *     item-page-list pageSize=-1 另拉，当前页只有 10 行不够循环交叉；每页都预填，且保存按
 *     明细行全量提交：后端行间联动按"库值+提交合并"全量校验，只交当前页时未提交页库值
 *     为空必现联动失败，分页存量包循环互审口径将落空）。循环交叉仅为默认勾选逻辑、非必要条件：
 *     初审可改派认证池任意非本人人员，前端预检与后端保存/派发均不校验"初审∈执行人集合"（用户口径）；
 *   质检=任务包发起人（发起任务包审核的建包员工，submit 优先、sender 回退），只读不可改；空值/老口径非发起人值
 *   前端归一为发起人（列只读无修正入口），空值后端保存兜底补发起人。
 * 状态门：仅待派发可改（readonly 由父组件按任务包状态传入）；派发后只读展示。
 * 未保存修改缓冲（dirtyByGuid，按行 guid 暂存三件套快照）：翻页 loadRows 整体替换 rows 实例、
 *   跨页勾选（reserve-selection）保留的是脱离 rows/allRows 的旧引用——行对象上的改动不进缓冲即丢。
 *   行内手改/批量设置即写入，新拉页与保存合并集按 guid 回放：手改翻页不丢、跨页批量真实落库，
 *   且用户显式值优先于循环交叉兜底（兜底只补回放后仍为空的行）。
-->
<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1080px" top="5vh" :close-on-click-modal="false" :before-close="onDialogClose" append-to-body>
    <div class="lpts-wrap">
      <div class="lpts-toolbar">
        <el-input v-model="keyword" placeholder="执行人姓名" size="mini" style="width: 180px" clearable
          @keyup.enter.native="search"></el-input>
        <el-button size="mini" type="info" class="lpts-search-btn" @click="search">查 询</el-button>
        <div class="lpts-toolbar-tip" v-if="!readonly">
          质检=任务包发起人（自动填入不可改）；初审默认交叉互审、可改派；初审/复审候选=执行方认证人员；三类人员不可与该行标注人员同人
        </div>
      </div>
      <el-table :data="rows" v-loading="loading" border height="420px" size="mini"
        @selection-change="onSelectionChange" :row-key="(row) => row.guid">
        <el-table-column v-if="!readonly" type="selection" width="42" fixed="left" reserve-selection></el-table-column>
        <el-table-column prop="staffName" label="标注人员" width="90" fixed="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planAmount" label="计划量" width="70" align="center"></el-table-column>
        <el-table-column prop="finishAmount" label="完成量" width="70" align="center"></el-table-column>
        <el-table-column label="驳回标记" width="70" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.rejectedFlag == 'Y' ? 'lpts-reject' : ''">
              {{ scope.row.rejectedFlag == 'Y' ? '有' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下发时间" width="96" align="center">
          <template slot-scope="scope">{{ (scope.row.staffAssignTime || '').slice(0, 10) || '-' }}</template>
        </el-table-column>
        <el-table-column width="150" align="center">
          <template slot="header">
            初审人员<el-button v-if="!readonly" type="text" size="mini" class="lpts-gear" title="批量设置勾选行"
              @click="openBatch('firstReview')"><i class="el-icon-setting"></i></el-button>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.firstReviewStaffGuid" placeholder="请选择" size="mini" filterable clearable
              :disabled="readonly" style="width: 120px" @change="(val) => onStaffPick(scope.row, 'firstReview', val)">
              <el-option v-for="s in reviewCandidates" :key="s.staffGuid" :label="s.staffName" :value="s.staffGuid"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="150" align="center">
          <template slot="header">
            复审人员<el-button v-if="!readonly" type="text" size="mini" class="lpts-gear" title="批量设置勾选行"
              @click="openBatch('secondReview')"><i class="el-icon-setting"></i></el-button>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.secondReviewStaffGuid" placeholder="请选择" size="mini" filterable clearable
              :disabled="readonly" style="width: 120px" @change="(val) => onStaffPick(scope.row, 'secondReview', val)">
              <el-option v-for="s in reviewCandidates" :key="s.staffGuid" :label="s.staffName" :value="s.staffGuid"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="150" align="center">
          <template slot="header">
            <span class="lpts-required">*</span>质检人员
          </template>
          <template slot-scope="scope">{{ scope.row.qcStaffName || '-' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="total > pageSize" class="lpts-pager" background layout="total, prev, pager, next"
        :total="total" :page-size="pageSize" :current-page.sync="pageIndex" @current-change="loadRows"></el-pagination>
    </div>

    <!-- 列头齿轮：批量设置（对勾选行统一赋该列人员；初审/复审同用执行方认证池） -->
    <el-dialog :title="`批量设置${batchColumnText}`" :visible.sync="batchVisible" width="420px" append-to-body
      :close-on-click-modal="false">
      <div class="lpts-batch-tip">将应用到已勾选的 {{ checkedRows.length }} 个执行人的【{{ batchColumnText }}】列</div>
      <el-select v-model="batchStaffGuid" placeholder="搜索并选择人员" size="small" filterable clearable
        style="width: 100%" :loading="staffLoading">
        <el-option v-for="s in batchPool" :key="s.staffGuid" :label="s.staffName" :value="s.staffGuid"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="batchVisible = false">取 消</el-button>
        <el-button size="small" type="info" @click="applyBatch">应用</el-button>
      </span>
    </el-dialog>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" plain @click="onDialogClose()">{{ readonly ? '关 闭' : '取 消' }}</el-button>
      <el-button v-if="!readonly" size="small" type="info" :loading="saving" @click="save">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 初审/复审下拉候选（执行方认证池∩执行部门范围）的模块级缓存（09-16 用户要求二次打开不再请求）：
// 按执行方租户+执行部门范围分桶——不同包的执行方（非转派=药企/转派=三方）与部门范围均不同，
// 且受理页执行部门可编辑，改范围后候选必须刷新，不能全局单值缓存；
// 人员清单低频变化，SPA 会话内复用；表格 rows 不缓存（完成量等随派发变化，每次打开必须重查）
const reviewPoolCache = {};

export default {
  name: "LabelPersonTaskSum",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 标注明细行GUID（tr_task_detail.guid，taskContentType=SJBZ） */
    taskDetailGuid: {
      type: String,
      default: "",
    },
    datasetName: {
      type: String,
      default: "",
    },
    /** 只读态（任务包非待派发：派发后不允许改派，后端状态门兜底） */
    readonly: {
      type: Boolean,
      default: false,
    },
    /** 执行方租户GUID（复审认证池用：非转派=委托方/药企、转派=三方） */
    candidateTenantGuid: {
      type: String,
      default: "",
    },
    /**
     * 执行部门范围（2026-11 初审/复审候选部门过滤口径）：{organisationGuids:[], staffGuids:[]}——
     * 备案包=执行部门、转派包=新执行部门（同一字段，父组件按页面当前值解析）；
     * 选人时传 staffGuids（后端取人对应部门过滤）。null/空=不限部门（兼容旧调用全池）
     */
    executionScope: {
      type: Object,
      default: null,
    },
    /** 质检默认=任务包发起人（sender 员工，父组件从包详情传入；行上为空时兜底预填） */
    qcDefaultGuid: {
      type: String,
      default: "",
    },
    qcDefaultName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      keyword: "",
      rows: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      checkedRows: [],
      executorCandidates: [], //执行人全集（循环交叉默认勾选映射源+保存全量集；2026-09-23 二修订后不再作下拉候选）
      reviewCandidates: [], //初审/复审下拉候选=执行方认证池（is_cert_audit=Y）
      staffLoading: false,
      batchVisible: false,
      batchColumn: "", //firstReview/secondReview（质检锁死只读，无批量入口）
      batchStaffGuid: "",
      allRows: [], //执行人全量行（pageSize=-1 另拉；保存按明细行全量提交，分页包行间联动须整列一致）
      dirtyByGuid: {}, //未保存修改缓冲（行guid→三件套快照）：翻页 loadRows 替换 rows 实例/跨页勾选行为孤儿引用，改动只进此缓冲才不丢
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    dialogTitle() {
      return `人员明细${this.readonly ? "" : "配置"}——${this.datasetName || ""}`;
    },
    batchColumnText() {
      return { firstReview: "初审人员", secondReview: "复审人员" }[this.batchColumn] || "";
    },
    batchPool() {
      // 初审/复审批量池同=执行方认证池（2026-09-23 二修订：初审候选与复审同池）
      return this.reviewCandidates;
    },
  },
  watch: {
    // immediate：父组件以 v-if 挂载本组件（visible 创建时即为 true），非 immediate 的 watch
    // 在创建时永不触发——表现为弹框打开列表不自动查询、三列人员候选恒空（09-16 用户实测）
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          if (!this.taskDetailGuid) {
            this.$message.error("缺少标注明细行标识");
            this.dialogVisible = false;
            return;
          }
          this.keyword = "";
          this.pageIndex = 1;
          this.allRows = [];
          this.dirtyByGuid = {};
          this.loadRows();
          this.loadExecutors();
          this.loadReviewCandidates();
        }
      },
    },
  },
  methods: {
    // 关闭拦截（2026-09-30，编辑态）：改了三件套没保存（dirty 缓冲非空）或存在质检未保存落库的人
    // （新加执行人 qc 库值为空——列表归一显示"发起人"掩盖空值，预检才暴露"质检人员未逐行配置"）时，
    // 提示去保存（保存后端会自动补发起人并关闭弹窗），仍要关闭则放行
    onDialogClose(done) {
      const doClose = () => {
        if (typeof done === "function") done();
        else this.dialogVisible = false;
      };
      if (this.readonly || !this.hasUnsavedConfig()) return doClose();
      this.$confirm("人员配置尚未保存，建议先保存。", "未保存提示", {
        confirmButtonText: "去保存",
        cancelButtonText: "仍要关闭",
        type: "warning",
      })
        .then(() => {
          this.save();
        })
        .catch(() => {
          doClose();
        });
    },
    // 未保存判定：dirty 缓存（用户手改未保存）或 allRows 存在库值质检为空的行
    // （allRows 是 item-page-list 全量镜像未经前端归一，qcStaffGuid 保持库值）
    hasUnsavedConfig() {
      if (Object.keys(this.dirtyByGuid).length) return true;
      return (this.allRows || []).some((r) => !r.qcStaffGuid);
    },
    loadRows() {
      this.loading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-task/item-page-list`, {
          taskDetailGuid: this.taskDetailGuid,
          keyword: this.keyword || "",
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            const page = res.data.data || {};
            this.rows = page.records || [];
            this.total = page.totalRows || this.rows.length;
            // 先回放未保存修改再走兜底预填：用户手改优先于循环交叉兜底（有值不覆盖语义按回放后判断）
            this.applyDirty(this.rows);
            this.prefillQcDefault(this.rows);
            this.ensureFirstReviewDefault(this.rows);
          } else {
            this.$message.error(res.data.msg || "人员明细查询失败");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 执行人全集（循环交叉默认勾选的映射源；当前页只有 pageSize 行不够映射，-1=全量工程惯例）
    // 全量行同时存 allRows：保存按明细行全量提交（后端行间联动按全量合并校验，只交当前页必现失败）
    loadExecutors() {
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-task/item-page-list`, {
          taskDetailGuid: this.taskDetailGuid,
          keyword: "",
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            const records = ((res.data.data || {}).records) || [];
            this.allRows = records;
            const seen = {};
            const list = [];
            records.forEach((r) => {
              if (r.staffGuid && !seen[r.staffGuid]) {
                seen[r.staffGuid] = true;
                list.push({ staffGuid: r.staffGuid, staffName: r.staffName });
              }
            });
            this.executorCandidates = list;
            this.ensureFirstReviewDefault(this.rows);
          }
        })
        .catch(() => {});
    },
    // 初审/复审下拉候选=执行方认证池∩执行部门范围（2026-11：备案=执行部门/转派=新执行部门；
    // 选人→取人对应部门。范围空=全池。保存/派发的后端复审校验仍为全池，下拉为引导性过滤）
    loadReviewCandidates() {
      if (!this.candidateTenantGuid) {
        this.$message.error("缺少执行方租户，复审候选无法加载");
        return;
      }
      const scope = this.executionScope || {};
      const orgs = Array.isArray(scope.organisationGuids) ? scope.organisationGuids.filter(Boolean) : [];
      const staffs = Array.isArray(scope.staffGuids) ? scope.staffGuids.filter(Boolean) : [];
      // 缓存 key=租户+范围：同租户不同部门范围不得复用（改执行部门后候选必须刷新）
      const cacheKey = this.candidateTenantGuid + "|" + orgs.join(",") + "|" + staffs.join(",");
      const cached = reviewPoolCache[cacheKey];
      if (cached) {
        this.reviewCandidates = cached;
        return;
      }
      this.staffLoading = true;
      const req = { tenantGuid: this.candidateTenantGuid };
      if (orgs.length) req.organisationGuids = orgs;
      if (staffs.length) req.staffGuids = staffs;
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-cert/label-assign-candidates`, req)
        .then((res) => {
          this.staffLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            reviewPoolCache[cacheKey] = res.data.data || [];
            this.reviewCandidates = reviewPoolCache[cacheKey];
          }
        })
        .catch(() => {
          this.staffLoading = false;
        });
    },
    // 质检兜底：行上为空或为老口径非发起人值时归一预填任务包发起人（存量老拆分包拆分早于默认值上线；
    // 质检列只读无人工修正入口，不归一则保存被后端"显式改派拒绝"卡死。用户无改派入口，归一属存量
    // 数据修复而非改派；API 直调显式传非发起人值后端仍拒）
    prefillQcDefault(list) {
      if (this.readonly || !this.qcDefaultGuid) return;
      list.forEach((row) => {
        if (row.qcStaffGuid !== this.qcDefaultGuid) {
          this.$set(row, "qcStaffGuid", this.qcDefaultGuid);
          this.$set(row, "qcStaffName", this.qcDefaultName);
        }
      });
    },
    // 初审存量兜底：受理拆分新版已写循环交叉默认；老拆分包打开时按执行人全集序循环预填（有值不覆盖）。
    // 每页 loadRows 后都跑（幂等）：分页包首页预填后未提交页库值仍空，翻页须继续预填展示，
    // 否则用户误以为后续页初审不配、保存必撞后端按明细行全量的行间联动校验
    ensureFirstReviewDefault(list) {
      if (this.readonly || !list || !list.length || !this.executorCandidates.length) return;
      if (list.some((r) => r.firstReviewStaffGuid)) return;
      this.applyFirstReviewFallback(list);
    },
    // 初审空行按执行人全集循环交叉补齐（第 i 人←第 i+1 人、末人←首人，有值不覆盖）；
    // 单执行人无交叉可能不补（留空=初审整列不配，联动全无合法）
    applyFirstReviewFallback(list) {
      const n = this.executorCandidates.length;
      if (this.readonly || n < 2) return;
      const map = {};
      this.executorCandidates.forEach((s, i) => {
        map[s.staffGuid] = this.executorCandidates[(i + 1) % n];
      });
      list.forEach((row) => {
        const reviewer = map[row.staffGuid];
        if (reviewer && !row.firstReviewStaffGuid) {
          this.$set(row, "firstReviewStaffGuid", reviewer.staffGuid);
          this.$set(row, "firstReviewStaffName", reviewer.staffName);
        }
      });
    },
    // 未保存修改快照入缓冲：翻页 loadRows 会整体替换 rows 实例（v-model 旧对象丢弃）、
    // 跨页勾选行是脱离 rows/allRows 的旧引用（孤儿对象），行对象上的改动不进缓冲即丢
    markDirty(row) {
      if (!row || !row.guid) return;
      this.dirtyByGuid[row.guid] = {
        firstReviewStaffGuid: row.firstReviewStaffGuid || "",
        firstReviewStaffName: row.firstReviewStaffName || "",
        secondReviewStaffGuid: row.secondReviewStaffGuid || "",
        secondReviewStaffName: row.secondReviewStaffName || "",
        qcStaffGuid: row.qcStaffGuid || "",
        qcStaffName: row.qcStaffName || "",
      };
    },
    // 回放未保存修改到目标行集（新拉页 rows 展示用 / save 合并集提交用），按行 guid 匹配
    applyDirty(list) {
      list.forEach((row) => {
        const d = this.dirtyByGuid[row.guid];
        if (!d) return;
        this.$set(row, "firstReviewStaffGuid", d.firstReviewStaffGuid);
        this.$set(row, "firstReviewStaffName", d.firstReviewStaffName);
        this.$set(row, "secondReviewStaffGuid", d.secondReviewStaffGuid);
        this.$set(row, "secondReviewStaffName", d.secondReviewStaffName);
        this.$set(row, "qcStaffGuid", d.qcStaffGuid);
        this.$set(row, "qcStaffName", d.qcStaffName);
      });
    },
    search() {
      this.pageIndex = 1;
      this.loadRows();
    },
    onSelectionChange(rows) {
      this.checkedRows = rows;
    },
    // 行内下拉选中/清空后同步姓名字段（初审/复审候选同池）并记入未保存缓冲（翻页后回放不丢）
    onStaffPick(row, column, val) {
      const hit = val ? this.reviewCandidates.find((s) => s.staffGuid === val) : null;
      const nameKey = { firstReview: "firstReviewStaffName", secondReview: "secondReviewStaffName" }[column];
      row[nameKey] = hit ? hit.staffName : "";
      this.markDirty(row);
    },
    openBatch(column) {
      if (!this.checkedRows.length) {
        this.$message.warning("请先勾选要批量设置的执行人");
        return;
      }
      this.batchColumn = column;
      this.batchStaffGuid = "";
      this.batchVisible = true;
    },
    applyBatch() {
      if (!this.batchStaffGuid) {
        this.$message.error("请选择人员");
        return;
      }
      // 直接写 guid+name 两个字段（onStaffPick 只同步姓名、guid 由行内下拉 v-model 负责，
      // 批量场景没有 v-model 载体，此前复用它导致只写姓名不写 guid=应用不生效）
      const guidKey = { firstReview: "firstReviewStaffGuid", secondReview: "secondReviewStaffGuid" }[this.batchColumn];
      const nameKey = { firstReview: "firstReviewStaffName", secondReview: "secondReviewStaffName" }[this.batchColumn];
      const hit = this.batchPool.find((s) => s.staffGuid === this.batchStaffGuid);
      this.checkedRows.forEach((row) => {
        this.$set(row, guidKey, this.batchStaffGuid);
        this.$set(row, nameKey, hit ? hit.staffName : "");
        // 跨页勾选行是脱离 rows/allRows 的旧引用：$set 只改孤儿对象不进保存合并集，
        // 须同步记入未保存缓冲，保存时按 guid 应用到全量合并集才随落库生效
        this.markDirty(row);
      });
      this.batchVisible = false;
    },
    // 保存前预演校验（与后端 item-assign 校验一致，按全量行校验；后端拦截文案原样透出）。
    // 初审不做范围校验——循环交叉互审仅为默认勾选逻辑、非必要条件（2026-09-23 用户口径，后端同口径不拦）
    validate(list) {
      for (const row of list) {
        if (!row.qcStaffGuid) return `【${row.staffName}】行质检人员缺失（应为任务包发起人自动填入）`;
      }
      const anyFirst = list.some((r) => r.firstReviewStaffGuid);
      const anySecond = list.some((r) => r.secondReviewStaffGuid);
      if (anyFirst && list.some((r) => !r.firstReviewStaffGuid)) return "初审人员行间联动不满足：任一执行人已设置则全部须设置";
      if (anySecond && list.some((r) => !r.secondReviewStaffGuid)) return "复审人员行间联动不满足：任一执行人已设置则全部须设置";
      for (const row of list) {
        const self = row.staffGuid;
        if (self && self === row.firstReviewStaffGuid) return `【${row.staffName}】初审人员与其标注人员为同一人（禁止自审）`;
        if (self && self === row.secondReviewStaffGuid) return `【${row.staffName}】复审人员与其标注人员为同一人（禁止自审）`;
        if (self && self === row.qcStaffGuid) return `【${row.staffName}】质检人员与其标注人员为同一人（禁止自审）`;
      }
      return "";
    },
    save() {
      // 保存按明细行全量提交（后端行间联动/自审按"库值+提交合并"全量校验，只交当前页时
      // 未提交页库值为空必现联动失败——分页存量老包唯一出路曾是逐页翻完，循环互审口径落空）：
      // 以全量行缓存为底，当前页用户修改按行 guid 覆盖
      const base = this.allRows.length ? this.allRows : this.rows;
      const byGuid = {};
      base.forEach((r) => { byGuid[r.guid] = r; });
      this.rows.forEach((r) => { byGuid[r.guid] = r; });
      const merged = base.map((r) => byGuid[r.guid]);
      // 回放未保存缓冲后再兜底：已翻走页的手改/跨页勾选的批量设置按 guid 进提交集，
      // 且用户显式值优先——循环交叉兜底只补回放后仍为空的行，不再静默替换用户改动
      this.applyDirty(merged);
      // 初审整列兜底：已有任一行设置初审则空行按循环交叉补齐（达成"全有"过联动校验）；
      // 整列全空=用户明确不配初审，原样提交（"全无"同样合法），不做预填
      if (merged.some((r) => r.firstReviewStaffGuid)) {
        this.applyFirstReviewFallback(merged);
      }
      // 质检空行补发起人（与后端 normalizeQcToSender 同口径，防全量校验对当前页外行误报缺失）
      this.prefillQcDefault(merged);
      const msg = this.validate(merged);
      if (msg) {
        this.$message.error(msg);
        return;
      }
      const req = {
        taskDetailGuid: this.taskDetailGuid,
        rows: merged.map((row) => ({
          itemGuid: row.guid,
          firstReviewStaffGuid: row.firstReviewStaffGuid || "",
          firstReviewStaffName: row.firstReviewStaffName || "",
          secondReviewStaffGuid: row.secondReviewStaffGuid || "",
          secondReviewStaffName: row.secondReviewStaffName || "",
          qcStaffGuid: row.qcStaffGuid || "",
          qcStaffName: row.qcStaffName || "",
        })),
      };
      this.saving = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-task/item-assign`, req)
        .then((res) => {
          this.saving = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("人员明细已保存");
            this.$emit("saved");
            this.dialogVisible = false;
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.lpts-wrap {
  text-align: left; /* 抵御全局 #app text-align:center 波及 */
}
.lpts-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.lpts-search-btn {
  margin-left: 12px; /* flex 布局下 el-button 相邻选择器的默认左间距不生效（前邻是 el-input 非 el-button） */
}
.lpts-toolbar-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
.lpts-gear {
  margin-left: 4px;
  padding: 0;
}
.lpts-required {
  color: #f56c6c;
}
.lpts-reject {
  color: #f56c6c;
}
.lpts-pager {
  margin-top: 8px;
  text-align: right;
}
.lpts-batch-tip {
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
}
</style>
